import * as React from "react";
const SvgTrash = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path d="M0 0h24v24H0z" data-name="Trazado 512" style={{
    fill: "none"
  }} /><path d="M6 19a2.006 2.006 0 0 0 2 2h8a2.006 2.006 0 0 0 2-2V7H6zM8 9h8v10H8zm7.5-5-1-1h-5l-1 1H5v2h14V4z" data-name="Trazado 513" /></svg>;
export { SvgTrash as ReactComponent };